// Vendor imports
const React = require('react')
// Client V2 common imports
const DownloadButton = require('client-v2/into-landing/containers/download-button/component-smart')
const useToggleState = require('client-v2/common/hooks/toggle-state')
// Entry imports
const IntoHeader = require('client-v2/into-landing/containers/header/component-smart')
const UserProfileFeed = require('./containers/feed/component-smart')
const SMSModal = require('client-v2/into-landing/containers/sms-modal/component-smart')

function IntoUserProfileLayout(props) {
  const { items, likeCount, user, onPaginate } = props
  const [isBlurred, toggleBlurred] = useToggleState(false)

  const handleSMSModal = React.useCallback(() => {
    const root = document.getElementById('root')
    if (isBlurred) {
      root.classList.remove('no-scroll')
    } else {
      root.classList.add('no-scroll')
    }
    toggleBlurred()
  }, [isBlurred, toggleBlurred])

  return (
    <React.Fragment>
      <SMSModal isBlurred={isBlurred} onDismiss={handleSMSModal} dismissOnOuterClick={true} />
      <div className={`flex flex-col h-screen md:overflow-hidden ${isBlurred ? 'blur-lg' : ''}`}>
        <IntoHeader onDownloadClick={handleSMSModal} />
        <div className="space-y-10 md:space-y-0 md:space-x-10 flex-1 overflow-y-scroll">
          <div className="md:w-80 md:float-left p-6 pt-0 md:pt-6 md:sticky md:top-0">
            <div className="space-y-8">
              <img
                className="shrink-0 inline-block aspect-square object-cover rounded-full w-40"
                src={user['photo_url']}
                alt={user['display_name']}
              />
              <div className="space-y-2">
                <p className="font-semibold text-3xl lg:text-5xl">{user['display_name']}</p>
                <p className="lg:text-2xl opacity-50">{`@${user.username}`}</p>
              </div>
              <DownloadButton
                className="btn btn-primary btn-dot"
                buttonText="Follow"
                onClick={handleSMSModal}
              />
              <p className="leading-tight opacity-75">{user.bio}</p>
              <div className="flex flex-col">
                <span className="flex space-x-3 items-center px-1 py-3 text-white border-b-2 border-white border-opacity-10 text-opacity-50 hover:text-opacity-100">
                  <span className="flex-1">Likes</span>
                  <span className="text-sm font-mono">{likeCount}</span>
                </span>
              </div>
            </div>
          </div>
          <UserProfileFeed items={items} onPaginate={onPaginate} />
        </div>
      </div>
      <div id="modal-container"></div>
      <div
        id="svelte-announcer"
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '0',
          top: '0',
          clip: 'rect(0, 0, 0, 0)',
          clipPath: 'inset(50%)',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: '1px',
          height: '1px'
        }}
      ></div>
    </React.Fragment>
  )
}

if (__DEV__) {
  // Prop-checking imports
  const Immutable = require('immutable')
  const PropTypes = require('prop-types')
  const ProfileUserRecord = require('client-v2/user-profile/containers/profile-user/record')
  IntoUserProfileLayout.propTypes = {
    items: PropTypes.instanceOf(Immutable.Iterable).isRequired,
    likeCount: PropTypes.string,
    user: PropTypes.instanceOf(ProfileUserRecord).isRequired,
    onPaginate: PropTypes.func
  }
}

module.exports = IntoUserProfileLayout
